import { c as clsx } from './clsx.m-3c237499.js';
import { h } from './index-16457198.js';
import { A as ARIA } from './constants-dbaf23dd.js';

const InternalNesLabel = ({ nesId, label, legend, helpText, hiddenLabel, required, tooltip, tooltipArrowOffset, showTooltipContent, eventDataTooltip, language, tooltipOnClick, }) => (h("div", { lang: language },
  h("div", { class: clsx({
      "nes-mb-1": !helpText,
      "nes-sr-only": hiddenLabel,
    }) },
    h("div", { class: clsx("nes-label", {
        "nes-gap-1": tooltip,
        "nes-gap-2": !tooltip,
      }) },
      label && (h("label", { class: "\n            nes-label__label\n            tsx-label", htmlFor: nesId }, label)),
      legend && (h("legend", { class: "\n            nes-label__label\n            tsx-label", slot: "legend" }, legend)),
      tooltip && (h("nes-tooltip-button", { eventData: eventDataTooltip, onClick: tooltipOnClick })),
      !required && (h("internal-nes-optional-label", { id: nesId ? nesId + ARIA.optional : "" }))),
    tooltip && showTooltipContent && (h("div", { class: "nes-pb-1 nes-relative nes--top-0.5" },
      h("nes-tooltip-content", { expanded: showTooltipContent, "arrow-x": tooltipArrowOffset }, tooltip)))),
  helpText && (h("nes-help-text", { class: "nes-mb-2", id: nesId ? nesId + ARIA.helpText : "" }, helpText))));

const getTooltipArrowOffset = (element) => { var _a, _b; return ((_b = (_a = element === null || element === void 0 ? void 0 : element.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(".tsx-label")) === null || _b === void 0 ? void 0 : _b.offsetWidth) + 20 || 100; };

export { InternalNesLabel as I, getTooltipArrowOffset as g };
